import { render, staticRenderFns } from "./TrafficPerWeek.vue?vue&type=template&id=2791d7e0&scoped=true&"
import script from "./TrafficPerWeek.vue?vue&type=script&lang=js&"
export * from "./TrafficPerWeek.vue?vue&type=script&lang=js&"
import style0 from "./TrafficPerWeek.vue?vue&type=style&index=0&id=2791d7e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2791d7e0",
  null
  
)

export default component.exports